import styles from "./index.module.scss";

const MinMaxInput = ({name, value, transformOnChange}) => {
  let {min, max} = value;

  return (
    <div className={styles.container}>
      <p className={styles.title}>{name}</p>
      <div className={styles.inputs_container}>
        <div className={styles.input_container}>
          <p>min</p>
          <input type="text" step="0.01" name={name + "-min"} defaultValue={min} onChange={transformOnChange} />
        </div>
        <div className={styles.input_container}>
          <p>max</p>
          <input type="text" step="0.01" name={name + "-max"} defaultValue={max} onChange={transformOnChange} />
        </div>
      </div>
    </div>
  );
};

export default MinMaxInput;
